import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    TruckCode:0,
    TrackingID:"",
    DriverName:"",
    TruckName:"",
    PurchaseDate:new Date(),
    OnService:"N",
    OnLease:"N",
    Sold:"N",
    WMS:"N",
    Length:"",
    Width:"",
    Height:"",
    CBM:"",
  }, 
};

const SliceTruck = createSlice({
  name: "SliceTruck",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_Truck_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_Truck_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_Truck_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_Truck_HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.DriverName = action.payload.DriverName; 
    } ,
    Set_Truck_HeadObject_CBM_Set: (state, action) => {
      state.value.HeadObject.CBM = action.payload.CBM; 
    } 
  },
});

export const {
  Set_Truck_Init,
  Set_Truck_HeadObject_Set, 
  Set_Truck_HeadObject_Init, 
  Set_Truck_HeadObject_New_Set,
  Set_Truck_HeadObject_CBM_Set
} = SliceTruck.actions;
export default SliceTruck.reducer;
